import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";

export function QrModal({ qr, onClose }) {
  return (
    <Dialog open={!!qr} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="qr-modal">
        <DialogHeader><DialogTitle>Guest check-in QR</DialogTitle></DialogHeader>
        {qr && (() => {
          const portalUrl = `${window.location.origin}/guest?booking=${qr.booking}&email=${encodeURIComponent(qr.email)}&token=${qr.token}`;
          const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=320x320&data=${encodeURIComponent(portalUrl)}`;
          return (
            <div className="flex flex-col items-center text-center">
              <img src={qrUrl} alt="Guest portal QR" className="rounded-md border border-border" width={280} height={280} data-testid="qr-image" />
              <div className="text-sm font-medium mt-4">{qr.email}</div>
              <div className="text-xs text-muted-foreground mt-1 break-all">{portalUrl}</div>
              <div className="mt-4 text-[11px] uppercase tracking-widest text-muted-foreground">Print and stick at the cottage door</div>
            </div>
          );
        })()}
        <DialogFooter>
          <Button variant="outline" onClick={() => window.print()} data-testid="qr-print-btn">Print</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
